if (!customElements.get('quick-add-modal')) {
	
	class QuickAddModal extends PopupModal {
		constructor() {
			super();

			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
			this.productUrl = this.getAttribute('data-product-url');
			this.variantsCount = parseInt(this.getAttribute('data-variants-count'), 10);
			this.innerPack = parseInt(this.getAttribute('data-inner-pack'), 10) || 0;
			this.productForm = this.querySelector('product-form');
			this.appendToBody = this.getAttribute('data-append-to-body');

			this.currentTriggerElement = null;

			if (this.appendToBody) {
				//move this component from current location to the end of the body
				document.body.appendChild(this);
			}
		}

		close() {
			// Clean up galleries before closing
			this.cleanupExistingGalleries();
			
			super.close(true, () => {
				if (this.modalContent) {
					this.modalContent.innerHTML = '';
				}
			});
		}

		open(triggerElement = null) {
			// Clean up any existing product galleries before opening
			this.cleanupExistingGalleries();

			// If single variant and no inner pack restrictions, add to cart immediately
			// Otherwise show popup to allow quantity selection
			if (this.variantsCount == 1 && this.innerPack === 0) {
				//add to cart immediately

				if (triggerElement) {
					this.currentTriggerElement = triggerElement;
					triggerElement.setAttribute('aria-disabled', true);
					triggerElement.classList.add('loading');
					triggerElement.querySelector('.loading__spinner').classList.remove('hidden');
				}

				console.log('submitting product form!!!');
				this.checkbox.checked = false;

				this.productForm.onSubmitHandler();

				return;
			}

			//set loading state inside the modal
			this.classList.add('loading');
			super.open();

			fetch(this.productUrl)
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					const productElement = responseHTML.querySelector('product-info');
					console.log('got productElement', productElement);

					// Re-query modalContent in case it wasn't found in constructor
					if (!this.modalContent) {
						this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
					}
					
					if (!this.modalContent) {
						console.error('QuickAddModal: modalContent not found');
						return;
					}

					this.preprocessHTML(productElement);
					HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}
					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					// Check for overflow after content is loaded
					if (super.checkAndAdjustOverflow) {
						setTimeout(() => {
							super.checkAndAdjustOverflow();
						}, 300);
					}
				})
				.finally(() => {
					this.classList.remove('loading');
				});
		}

		preprocessHTML(productElement) {
			console.log('preprocessHTML', productElement);
			this.preventDuplicatedIDs(productElement);
			this.removeDOMElements(productElement);
			this.preventVariantURLSwitching(productElement);
			this.updateGallery(productElement);

			productElement.classList.remove('border-b');
			const productInfoContent = productElement.querySelector('.product-info-content');
			if (productInfoContent) {
				productInfoContent.classList.remove('lg:border-l', 'lg:border-dark-100', 'xl:w-[32rem]');
			}
		}

		preventDuplicatedIDs(productElement) {
			console.log('preventDuplicatedIDs', productElement);
			const sectionId = productElement.dataset.section;

			const oldId = sectionId;
			const newId = `quickadd-${sectionId}`;
			productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
			Array.from(productElement.attributes).forEach((attribute) => {
				if (attribute.value.includes(oldId)) {
					productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
				}
			});

			productElement.dataset.originalSection = sectionId;
		}

		preventVariantURLSwitching(productElement) {
			productElement.setAttribute('data-update-url', 'false');
		}

		removeDOMElements(productElement) {
			const pickupAvailability = productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const modalDialog = productElement.querySelectorAll('quick-add-modal');
			if (modalDialog) modalDialog.forEach((modal) => modal.remove());
		}

		updateGallery(productElement) {
			const gallery = productElement.querySelector('product-gallery');
			if (gallery) {
				gallery.classList.add('quick-add-gallery');
				if (gallery.closest('.product-gallery')) {
					gallery.closest('.product-gallery').classList.add('quick-add-gallery-wrapper');
				}

				const galleryImages = gallery.querySelector('.gallery-images');
				const galleryThumbnails = gallery.querySelector('.gallery-thumbnails');
				const swiperSlides = gallery.querySelectorAll('swiper-slide');
				let classesToRemove = [];
				
				if (galleryImages) {
					// Remove classes that begin with xl: or 2xl:
					classesToRemove = Array.from(galleryImages.classList).filter(className => 
						className.startsWith('xl:') || className.startsWith('2xl:')
					);
					classesToRemove.forEach(className => galleryImages.classList.remove(className));
				}

				if (galleryThumbnails) {
					classesToRemove = Array.from(galleryThumbnails.classList).filter(className => 
						className.startsWith('xl:') || className.startsWith('2xl:')
					);
					classesToRemove.forEach(className => galleryThumbnails.classList.remove(className));
				}

				if (swiperSlides) {
					swiperSlides.forEach(slide => {
						classesToRemove = Array.from(slide.classList).filter(className => 
							className.startsWith('xl:') || className.startsWith('2xl:')
						);
						classesToRemove.forEach(className => slide.classList.remove(className));
					});
				}
			}
		}

		cleanupExistingGalleries() {
			// Clean up any existing product galleries in the modal content
			const existingGalleries = this.modalContent?.querySelectorAll('product-gallery');
			if (existingGalleries) {
				existingGalleries.forEach(gallery => {
					if (gallery.cleanup) {
						gallery.cleanup();
					}
				});
			}
		}

		afterAddToCart() {
			if (this.currentTriggerElement) {
				this.currentTriggerElement.removeAttribute('aria-disabled');
				this.currentTriggerElement.classList.remove('loading');
				this.currentTriggerElement.querySelector('.loading__spinner').classList.add('hidden');
			}
			if (this.isOpen()) {
				this.close();
			}
		}
	}

	customElements.define('quick-add-modal', QuickAddModal);
}